
function About() {
  return (
    <div>
        <h1 className="text-6xl mb-4">
            Github Finder
        </h1>
        <p>
            This is a project which helps you search Github, look at specific profiles and the latest repositories of a user, among other information.
        </p>
    </div>
  )
}

export default About